import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpf'
})
export class CpfPipe implements PipeTransform {

  transform(value: any): string {
    if (!value) return '';

    const original = value.toString();

    // Se tiver qualquer letra, não formata
    if (/[a-zA-Z]/.test(original)) {
      return original;
    }

    // Mantém somente números
    const numbers = original.replace(/\D/g, '');

    // Só formata se tiver exatamente 11 dígitos
    if (numbers.length !== 11) {
      return original;
    }

    // Formata CPF
    return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
}
